import { NameEntityResponse } from "../../api-models/response/NameEntityResponse";
import { ReportTemplateResponse } from "../../api-models/response/organization/ReportTemplateResponse";
import { RowItemData } from "../../components/datatable/interfaces";
import { formatBytes, formatNumberBasedOnLanguage } from "../../helpers/MathHelpers";
import dateService from "../date-service/DateService";

export class ReportTemplate implements RowItemData {
  id: number;
  name: string;
  private projectsCount: number;
  private uploadedBy: NameEntityResponse;
  private uploadedDate: Date;
  private size: number;
  private lastEdit: Date;

  constructor(reportTemplateResponse: ReportTemplateResponse) {
    this.id = reportTemplateResponse.id;
    this.name = reportTemplateResponse.name;
    this.projectsCount = reportTemplateResponse.projectsCount;
    this.uploadedBy = reportTemplateResponse.uploadedBy;
    this.uploadedDate = reportTemplateResponse.uploadedDate;
    this.size = reportTemplateResponse.size;
    this.lastEdit = reportTemplateResponse.lastEdit;
  }

  get displayValues() {
    return {
      name: { toDisplay: this.name },
      uploadedBy: { toDisplay: this.uploadedBy.name },
      projectsCount: { toDisplay: this.projectsCount },
      uploadedDate: { toDisplay: dateService.formatDate(this.uploadedDate) },
      size: { toDisplay: this.formattedSize },
      lastEdit: { toDisplay: dateService.formatDate(this.lastEdit) }
    };
  }

  private get formattedSize() {
    const formattedBytes =
      this.size && `${formatBytes(this.size).amount} ${formatBytes(this.size).unit}`;
    return formatNumberBasedOnLanguage(formattedBytes);
  }
}
